import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-discount-animation',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="discount-wrapper" [@bounceAnimation]="'active'">
      <div class="percentage-wrapper">
        <span class="percentage">{{percentage}}</span>
        <div class="discount-details">
          <span class="percent-sign">%</span>
          <span class="off">OFF</span>
        </div>
      </div>
      <div class="shine"></div>
      <div class="burst-rays"></div>
      <div class="sparkles"></div>
    </div>
  `,
  styles: [`
    .discount-wrapper {
      position: relative;
      display: inline-block;
      padding: 1rem;
      transform-origin: center;
    }

    .percentage-wrapper {
      display: flex;
      align-items: baseline;
      position: relative;
      z-index: 2;
    }

    .percentage {
      font-size: 8rem;
      font-weight: 800;
      line-height: 1;
      background: linear-gradient(135deg, #fff 30%, #ffd700 70%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.3);
      animation: glowPulse 2s infinite;
    }

    .discount-details {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .percent-sign {
      font-size: 3rem;
      font-weight: 700;
      color: white;
    }

    .off {
      font-size: 2rem;
      font-weight: 700;
      color: white;
    }

    .shine {
      position: absolute;
      top: 0;
      left: -100%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.4),
        transparent
      );
      animation: shine 2s infinite;
      transform: skewX(-20deg);
    }

    .burst-rays {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120%;
      height: 120%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.2) 0%,
        transparent 70%
      );
      animation: burst 2s infinite;
    }

    .sparkles {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
    }

    .sparkles::before,
    .sparkles::after {
      content: '';
      position: absolute;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: white;
      animation: sparkle 1.5s infinite;
    }

    .sparkles::before {
      top: 20%;
      left: 20%;
      animation-delay: 0.2s;
    }

    .sparkles::after {
      bottom: 20%;
      right: 20%;
      animation-delay: 0.8s;
    }

    @keyframes glowPulse {
      0% { text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); }
      50% { text-shadow: 0 0 20px rgba(255, 255, 255, 0.8); }
      100% { text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); }
    }

    @keyframes shine {
      0% { left: -100%; opacity: 0; }
      20% { opacity: 1; }
      35% { left: 100%; opacity: 0; }
      100% { left: 100%; opacity: 0; }
    }

    @keyframes burst {
      0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.3; }
      50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.7; }
      100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.3; }
    }

    @keyframes sparkle {
      0% { transform: scale(0) rotate(0deg); opacity: 0; }
      50% { transform: scale(1) rotate(180deg); opacity: 1; }
      100% { transform: scale(0) rotate(360deg); opacity: 0; }
    }
  `],
  animations: [
    trigger('bounceAnimation', [
      state('active', style({ transform: 'scale(1)' })),
      transition('void => active', [
        animate('1s', keyframes([
          style({ transform: 'scale(0)', offset: 0 }),
          style({ transform: 'scale(1.2)', offset: 0.6 }),
          style({ transform: 'scale(0.9)', offset: 0.8 }),
          style({ transform: 'scale(1)', offset: 1 })
        ]))
      ])
    ])
  ]
})
export class DiscountAnimationComponent {
  @Input() percentage: number = 50;
}